/* eslint-disable react/destructuring-assignment */

import * as React from 'react';

import { logError } from '../helpers/logging';

interface ErrorBoundaryProps {
	fallbackComponent: React.ReactNode;
}

interface ErrorBoundaryState {
	hasError: boolean;
}

class ErrorBoundary extends React.Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	componentDidCatch(error: Error, info: React.ErrorInfo): void {
		this.setState({ hasError: true });

		let shouldLogError = true;
		if (
			error instanceof Error &&
			error.stack &&
			error.stack.indexOf('static.scarabresearch.com') !== -1
		) {
			// Skip any errors eminating from this particular script because they're nothing to do with us
			shouldLogError = false;
		}

		if (shouldLogError) {
			logError(error, info.componentStack);
		}
	}

	render(): React.ReactNode {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return this.props.fallbackComponent;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
